module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/redirect-locale/redirect-locale.component.css
// module id = ./src/app/redirect-locale/redirect-locale.component.css
// module chunks = main